var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-end gap-2"},[_c('filter-toggler')],1)}
var staticRenderFns = []

export { render, staticRenderFns }